<template>
  <div>
    <div style="margin-bottom: 15px">
      <span>选择学校：</span>
      <a-select v-model="bizOrgId" :allowClear="true" style="width: 10%" @change="handleBizOrgChange">
        <a-select-option v-for="bizOrg in bizOrgList" :value="bizOrg.id" :key="bizOrg.id">
          {{ bizOrg.name }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">姓名或手机号：</span>
      <a-input allow-clear v-model="keyword" style="width: 10%"/>
      <span style="margin-left: 12px">选择年级：</span>
      <a-select v-model="grade" :allowClear="true" style="width: 10%" @change="handleGradeChange">
        <a-select-option v-for="g in gradeList" :value="g" :key="g">
          {{ g }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">选择班级：</span>
      <a-select v-model="className" :allowClear="true" style="width: 10%">
        <a-select-option v-for="c in classList" :value="c" :key="c">
          {{ c }}
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">性别：</span>
      <a-select v-model="gender" :allowClear="true" style="width: 5%">
        <a-select-option value="male" key="male">
          男
        </a-select-option>
        <a-select-option value="female" key="female">
          女
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">衣袋号/标签号：</span>
      <a-input allow-clear v-model="pocketNoOrLabelNo" style="width: 10%"/>
    </div>
    <div style="margin-bottom: 15px">
      <span>衣袋绑定状态：</span>
      <a-select v-model="bindStatus" :allowClear="true" style="width: 10%">
        <a-select-option value="true" key="1">
          已绑定
        </a-select-option>
        <a-select-option value="false" key="0">
          未绑定
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">衣袋打印状态：</span>
      <a-select v-model="printStatus" :allowClear="true" style="width: 10%">
        <a-select-option value="true" key="1">
          已打印
        </a-select-option>
        <a-select-option value="false" key="0">
          未打印
        </a-select-option>
      </a-select>
      <span style="margin-left: 12px">会员状态：</span>
      <a-select v-model="memberStatus" :allowClear="true" style="width: 10%">
        <a-select-option value="noRecharge" key="noRecharge">
          未充值
        </a-select-option>
        <a-select-option value="expired" key="expired">
          已过期
        </a-select-option>
        <a-select-option value="normal" key="normal">
          正常
        </a-select-option>
      </a-select>
    </div>
    <div style="margin-bottom: 15px">
      <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
      <a-button type="primary" style="margin-left: 15px" @click="handleBatchBind">批量绑定</a-button>
      <a-button type="primary" icon="export" style="margin-left: 15px" @click="handleExport">导出</a-button>
    </div>

    <a-table
        :columns="columns"
        :data-source="rows"
        :pagination="pagination"
        @change="handleTableChange"
        size="middle"
        :loading="loading"
        rowKey="id"
        bordered>
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="gender" slot-scope="text, record">
        {{ text ? (text === 'male' ? '男' : '女') : '' }}
      </span>
      <template slot="expired" slot-scope="text, record">
        <a-tag v-if="text === null" color="#9c9b9b">
          未充值
        </a-tag>
        <a-tag v-else-if="text" color="red">
          已过期
        </a-tag>
        <span v-else >
          <a-badge v-if="!record.printTime" count="新用户" :offset="[8,-3]">
            <a-tag color="green">正常</a-tag>
          </a-badge>
          <a-tag v-else color="green">正常</a-tag>
        </span>
      </template>
      <template slot="pocketNoOrLabelNo" slot-scope="text, record">
        <span v-if="record.pocketNo" style="text-align: left; display: block;">衣袋号：<a-tag
            color="blue">{{ record.pocketNo }}</a-tag></span>
        <template v-if="record.labelNos && record.labelNos.length > 0">
          <span style="text-align: left; display: block;" v-for="(labelNo,index) in record.labelNos" :key="labelNo">
            <span v-if="labelNo && labelNo !== ''">
              <br/>标签{{ index + 1 }}：<a-tag color="green">{{ labelNo }}</a-tag>
            </span>
          </span>
        </template>
      </template>
      <template slot="action" slot-scope="text, record">

        <a-button style="padding: 0 3px;" type="link" @click="$refs.editForm.showForm(record)">
          <a-icon type="container"/>
          <span style="margin-left: 2px">详细资料</span>
        </a-button>
        <a-divider type="vertical"/>
        <a-divider type="vertical"/>
        <a-button style="padding: 0 3px;" type="link" @click="$refs.bizRecordDialog.showModal(record.id)">
          <a-icon type="history"/>
          <span style="margin-left: 2px">变更记录</span>
        </a-button>
        <br>
        <a-button :disabled="!(record.expired === false)" style="padding: 0 3px;" type="link" @click="$refs.pocketBindForm.showForm(record)">
          <a-icon type="skin"/>
          <span style="margin-left: 2px">衣袋绑定</span>
        </a-button>
        <a-divider type="vertical"/>
        <a-button :disabled="!record.pocketNo" style="padding: 0 3px;" type="link" @click="handlePrint(record)">
          <a-icon type="printer"/>
          <span style="margin-left: 2px">{{ record.printTime ? '已打印' : '衣袋打印' }}</span>
        </a-button>
      </template>
    </a-table>
    <edit-form form-type="consume" ref="editForm"></edit-form>
    <user-biz-record-dialog ref="bizRecordDialog"></user-biz-record-dialog>
    <pocket-bind-form ref="pocketBindForm"></pocket-bind-form>
    <batch-bind-form ref="batchBindForm" @print="handlePrint"></batch-bind-form>

    <!-- 调整后的打印区域 -->
    <!-- 带框线的打印区域 -->
    <!-- 调整后的打印区域 -->
    <div id="print-area" v-if="showPrintArea" style="position: fixed; top: -9999px; left: -9999px;">
      <table style=" border-collapse: collapse; font-family: Arial, sans-serif; font-size: 11px; height: 105px; border: 0 solid #000;">
        <tr style="height: 105px">
          <td style="width: 90px; display: table-cell; vertical-align: middle; text-align: center; border: 0 solid #000;">
            <img :src="printData.qrCode" style="width: 85px; height: 85px;"/>
          </td>
          <td style="width: 210px; display: table-cell; vertical-align: middle; text-align: left; border: 0 solid #000;">
            <div>编号：{{ printData.pocketNo }}</div>
            <div>学校：{{ printData.bizOrgName }}</div>
            <template v-if="printData.bizOrgId === BIZ_ORG_ID.YINGCAI">
              <div>手机号：{{ printData.mobile.substr(0, 7) + "****" }}</div>
              <div>学生：{{ printData.realName + "（" + printData.grade + "）"}}</div>
            </template>
            <template v-else>
              <div>班级：{{ printData.grade }} {{ printData.className }}</div>
              <div>学生：{{ printData.realName }}</div>
            </template>
            <div>标签：<div style="display: inline-block; font-size: 10px">{{ printData.labelNos?.[0] }}、{{ printData.labelNos?.[1] }}、{{ printData.labelNos?.[2] }}</div></div>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import userService from '@/service/user'
import bizOrgService from '@/service/bizOrg'
import UserBizRecordDialog from "./UserBizRecordDialog.vue";
import Icon from "ant-design-vue/es/icon";
import EditForm from "./EditForm";
import PocketBindForm from "./PocketBindForm";
import BatchBindForm from "./BatchBindForm"
import vendorAdmin from "@/service/vendorAdmin";
import moment from "moment";
import {BIZ_ORG_ID} from "@/constants";

export default {
  name: "UserList",
  components: {UserBizRecordDialog, EditForm, PocketBindForm, BatchBindForm},
  data() {
    return {
      columns: [
        {title: '#', scopedSlots: {customRender: 'serial'}, align: 'center'},
        {title: '姓名', dataIndex: 'realName', align: 'center'},
        {title: '性别', dataIndex: 'gender', scopedSlots: {customRender: 'gender'}, align: 'center'},
        {title: "学校", dataIndex: 'bizOrgName', align: 'center'},
        {title: '手机号', dataIndex: 'mobile', align: 'center'},
        {title: '年级班级', dataIndex: 'grade', align: 'center', customRender: (text, record) => (record.grade ? record.grade : '') + (record.className ? record.className : '')},
        // {title: '注册时间', width: "10%", dataIndex: 'created', align: 'center' },
        {title: '会员状态', dataIndex: 'expired', scopedSlots: {customRender: 'expired'}, align: 'center'},
        {title: '会员有效期至', dataIndex: 'expireDate', align: 'center'},
        {title: '衣袋号/标签号', dataIndex: 'pocketNoOrLabelNo', scopedSlots: {customRender: 'pocketNoOrLabelNo'}, align: 'center'},
        {title: '操作', dataIndex: 'action', scopedSlots: {customRender: 'action'}, align: 'center'}
      ],
      rows: [],
      pagination: {},
      keyword: '',
      bizOrgId: null,
      grade: '',
      className: '',
      bizOrgList: [],
      gender: '',

      pocketNoOrLabelNo: '',
      memberStatus: '',
      bindStatus: null,
      printStatus: null,

      // 添加打印相关数据
      printData: {},
      currentTime: '',
      // 添加控制打印区域显示的数据
      showPrintArea: true,

      loading: false
    };
  },
  computed: {
    BIZ_ORG_ID() {
      return BIZ_ORG_ID
    },
    gradeList() {
      if (!this.bizOrgId) {
        return [];
      }
      return this.bizOrgList.find(item => item.id === this.bizOrgId)?.grades.map(item => item.name)
    },
    classList() {
      if (!this.grade) {
        return [];
      }
      return this.bizOrgList.find(item => item.id === this.bizOrgId)?.grades?.find(item => this.grade === item.name)?.classes
    }
  },
  mounted() {
    let params = {
      current: 1,
      size: 10,
    }
    this.fetch(params)

    bizOrgService.queryBriefList().then((res) => {
      this.bizOrgList = res.data
    })
  },
  methods: {
    handleTableChange(pagination) {
      this.fetch(pagination)
    },
    handleSearch() {
      this.fetch()
    },
    handleBizOrgChange() {
      this.grade = this.gradeList[0]
      this.className = this.classList[0]
    },
    handleGradeChange() {
      this.className = this.classList[0]
    },
    fetch(page) {
      let params = {
        current: page ? page.current : 1,
        size: page ? page.size : 10,
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        grade: this.grade,
        className: this.className,
        gender: this.gender,
        pocketNoOrLabelNo: this.pocketNoOrLabelNo,
        memberStatus: this.memberStatus,
        bindStatus: this.bindStatus,
        printStatus: this.printStatus
      }
      this.loading = true
      userService.queryPage(params).then((res) => {
        const pagination = {...this.pagination};
        this.rows = res.data.records
        pagination.current = res.data.current
        pagination.total = res.data.total
        pagination.size = res.data.size + ''
        pagination.showTotal = (total, range) => {
          return `${range[0]}-${range[1]} 总计 ${total} 条`
        }
        this.pagination = pagination
        this.loading = false
        this.$emit('refreshNotification')
      }).catch(e => {
        this.loading = false
      })
    },
    handleExport() {
      let params = {
        keyword: this.keyword,
        bizOrgId: this.bizOrgId,
        grade: this.grade,
        className: this.className,
        gender: this.gender,
        pocketNoOrLabelNo: this.pocketNoOrLabelNo,
        memberStatus: this.memberStatus,
        bindStatus: this.bindStatus,
        printStatus: this.printStatus
      }
      userService.export(params);
    },
    // 添加打印方法
    async handlePrint(record) {
      if (record.printTime) {
        let res = await new Promise((resolve, reject) => {
          this.$confirm({
            title: '请确认',
            content: `当前用户已在${record.printTime}打印过，确认再次打印？`,
            okText: '确认',
            cancelText: '取消',
            onOk() {
              resolve(true);
            },
            onCancel() {
              reject(false);
            },
          });
        })
        if (!res) {
          return
        }
      }
      record.printTime = moment().format("YYYY-MM-DD HH:mm:ss")
      userService.updatePrintTime(record.id).then(() => {
        this.$emit('refreshNotification')
      })
      // 设置打印数据
      this.printData = record;

      // 确保DOM更新后再执行打印
      this.$nextTick(() => {
        this.printDiv('print-area');
      });
    },
    handleBatchBind() {
      let records = this.rows.filter(record => record.expired === false && (!record.pocketNo || record.pocketNo === ''));
      if (records.length === 0) {
        this.$message.warning('当前页面没有未绑定衣袋的用户')
        return
      }
      this.$refs.batchBindForm.showForm(records)
    },

    // 打印功能实现
    // 打印功能实现（改进版）
    printDiv(divId) {
      const printContents = document.getElementById(divId).innerHTML;

      // 创建打印窗口
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`        <html>
          <head>
            <title>衣袋打印</title>
          </head>
          <body>${printContents}</body>
        </html>
      `);


      printWindow.document.close();
      printWindow.focus();

      // 等待内容加载完成后打印
      printWindow.onload = function () {
        printWindow.print();
        printWindow.close();
      };

      // 如果 onload 不触发，使用 setTimeout 作为备选方案
      setTimeout(function () {
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  }
}
</script>
